import { createSlice } from '@reduxjs/toolkit';

export const toastSlice = createSlice({
	name: 'toast',
	initialState: {
		toasts: [],
	},
	reducers: {
		showToast: (state, { payload }) => {
			const id = payload?.id ?? payload?.toastId ?? Math.random();
			const existingIndex = state.toasts.findIndex((toast) => toast.id === id);

			if (existingIndex !== -1) {
				state.toasts.splice(existingIndex, 1);
			}

			state.toasts.push({
				id, // keep stable for hideToast(toastId)
				instanceId: Math.random(), // new every show → forces remount
				message: payload.message ?? '',
				action: payload.action ?? null,
				error: payload.error ?? false,
				success: payload.success ?? false,
				duration: payload.duration ?? 6000,
				autohide: payload.autohide ?? true,
				loading: payload.loading ?? false,
				params: payload.params ?? { state: {} },
				sx: payload.sx ?? {},
			});
		},
		// showToast: (state, { payload }) => {
		// 	const id = payload?.id ?? payload?.toastId ?? Math.random();
		// 	const existingIndex = state.toasts.findIndex((toast) => toast.id === id);
		// 	const existing = state.toasts[existingIndex];
		// 	if (!existing) {
		// 		state.toasts.push({
		// 			id,
		// 			message: payload.message ?? '',
		// 			action: payload.action ?? null,
		// 			error: payload.error ?? false,
		// 			success: payload.success ?? false,
		// 			duration: payload.duration ?? 6000,
		// 			autohide: payload.autohide ?? true,
		// 			loading: payload.loading ?? false,
		// 			params: payload.params ?? { state: {} },
		// 			sx: payload.sx ?? {},
		// 		});
		// 	} else if (existing && payload.message && existing.message !== payload.message) {
		// 		state.toasts[existingIndex] = {
		// 			id,
		// 			message: payload.message ?? '',
		// 			action: payload.action ?? null,
		// 			error: payload.error ?? false,
		// 			success: payload.success ?? false,
		// 			duration: payload.duration ?? 6000,
		// 			autohide: payload.autohide ?? true,
		// 			loading: payload.loading ?? false,
		// 			params: payload.params ?? { state: {} },
		// 			sx: payload.sx ?? {},
		// 		};
		// 	}
		// },
		hideToast: (state, { payload }) => {
			state.toasts = state.toasts.filter((toast) => toast.id !== payload);
		},
		clearToasts: (state) => {
			state.toasts = [];
		},
	},
});

export const { showToast, hideToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
